import { ip } from "src/app/constant/constant";

export const environment = {
  production: true,
  ip: '/fantasy/',
  serviceurl: '/fantasy/',
  currentAiTokenCost: 5,
  imgUrl: '/fantasy/media/',
  stripePublishableKey: "pk_test_51TXaykP8ezbLKjMaWoFsn2qbMePsbSkqbSpDbRsUBB13XRFMUdZ3j1NzTFllK3NezT0KOsniqLSNYGs2OSBlANud0060axfpnA",
  stripePricingTableId: "prctbl_1T1L6204tvZp75Kc1CCSyYKP",
  wp_store_url: "https://test.worldtumbler.com/",
  WORLD_TUMBLER_URL: 'https://test.worldtumbler.com/wp-login.php?auth0=1&redirect_to=https://test.worldtumbler.com',
  geoserver_url: "",
  logouturl: "https://testapp.worldtumbler.com/application/home",
  auth: {
    "domain": "dev-qfl381rhyq3khajr.us.auth0.com",
    "clientId": "pnNREkt6kyD1QJlsBigVELQrIKoMzLqX",
    authorizationParams: {
      audience: "https://dev-qfl381rhyq3khajr.us.auth0.com/api/v2/",
      redirect_uri: "https://testapp.worldtumbler.com/application/auth0",
    },
  },


  httpInterceptor: {
    allowedList: ["https://testapp.worldtumbler.com/application/", "https://testapp.worldtumbler.com/fantasy", "https://testapp.worldtumbler.com/application/auth0"],
  },
};
